import { useCtx } from "@al/next/al-ex";
import { PriceTools, CountryCode } from "@al/base-lib";

export const usePriceFormat = (countryCode?: string) => {
  const ctx = useCtx();
  return (
    price: string | number,
    format: "shortprice" | "price" = "shortprice",
    needCurrencyCode?: boolean
  ): string | number | null =>
    PriceTools.formatPrice(
      (countryCode || ctx.locale.countryCode) as CountryCode,
      Number(price),
      format,
      needCurrencyCode
    );
};

export const usePriceFormat2object = (countryCode?: string) => {
  const ctx = useCtx();
  return (price: string | number, format: "shortprice" | "price" = "shortprice") =>
    PriceTools.formatPrice2object({
      countryCode: (countryCode || ctx.locale.countryCode) as CountryCode,
      value: Number(price),
      format,
    });
};
